module.exports = __webpack_public_path__ + "img/icon4.png";